import './PracticesCarousel.scss'

import { getAllPracticesDetails } from 'components/common/api/Practices'
import { useState } from 'react'
import { Card, Carousel } from 'react-bootstrap'

const _practices = getAllPracticesDetails()

/**
 * Simple Practices carousel component. Used during onboarding
 */
export default function PracticesCarousel() {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <>
      <Carousel
        activeIndex={activeIndex}
        onSelect={setActiveIndex}
        interval={null}
        controls={false}
        className='practice-carousel'
      >
        {_practices.map(practice => (
          <Carousel.Item key={practice.key}>
            <Card className='practice-carousel-card' key={practice.key}>
              <Card.Img
                className='practice-carousel-card-image'
                variant='top'
                src={practice.image}
              />
              <Card.Body>
                <Card.Title>{practice.title}</Card.Title>
                <Card.Text>{practice.description}</Card.Text>
              </Card.Body>
            </Card>
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  )
}
